import NoVideoPresentationComponent from "./NoVideoPresentationComponent";

export default NoVideoPresentationComponent;